import SBRCaseHome from "SBR/CaseHome";
import CaseHome from "../CaseHome";
import { useShowSBR } from "SBR/useShowSBR";

export function CaseHomeRoute() {
  const showSbr = useShowSBR();

  return showSbr ? <SBRCaseHome /> : <CaseHome />;
}
